import React from 'react';
import styled from "styled-components"
import WelcomeBody from './WelcomeBody'
import ActionItem from '../ActionItem';
import getImg from '../../../Utils/getImg.js';


const CustomWelcomeBody = styled(WelcomeBody)`
    color: #fff;
	padding : 30px 0;
	overflow : auto;
	/*z-index: 2;*/
`

const WelcomeText = styled.div`
    font-size: 16px;
    margin-bottom : 30px;
	padding : 0 30px;
    & div{
        font-size : 28px;
        font-weight : 300;
    }
`

const QuickLinksBlock = styled.div`
    display : flex;
    flex-direction : column;
	margin : 20px 0;
`

const CustomQuickLink = styled.div`
	border-bottom : 0.5px solid #606a91;
	display : flex;
	align-items:center;
	padding : 15px 0;


	> img {
		margin-left : 30px;
	}

	& > div{
		font-size : 14px;
		color: #fff;
		width : 100%;
		border: 0;
		border-radius : 0;
		background : transparent;
		padding : 0;
		margin : 0;
		margin-left : 15px;
	}

	& > div:hover{
		background : transparent;
		animation : none;
	}
`
const quickLinks = [
	{
		actionLabel: "Pay Bills/Recharge",
		actionValue: "Pay Bills/Recharge"
	},
	{
		actionLabel: "Track Application",
		actionValue: "Track Application"
	},
	{
		actionLabel: "Apply Credit Card",
		actionValue: "Apply Credit Card"
	},
	{
		actionLabel: "My Account",
		actionValue: "My Account"
	}
]

const Theme1 = (props) => {
	if(!props.showWelcomeScreen){
			return null;
	}
	return (
		<CustomWelcomeBody {...props}>
			<WelcomeText {...props}>
			{ !!props.data.welcomeMessage ? 
				<React.Fragment>
					<div>
						Hello 👋
					</div>
					{props.data.welcomeMessage.replace(/hi.?,?|hello.?,?|hey!|hey.?,?/i,"")}
				</React.Fragment>
			: 
				<React.Fragment>
				<div>
					Hello 👋
				</div>
				This is EVA, your personal digital assistant for anything and everything related to HDFC Bank
				</React.Fragment>
			}
			</WelcomeText>
			<div style={{fontSize : "13px",paddingLeft:"30px"}}>
				Here are some quick links
			</div>
			<QuickLinksBlock>
				{
					props.quickLinks.map((e, i) => {
						return (
							<CustomQuickLink key={i} >
								<img onError={(e)=>{e.target.src = getImg(`welcomeScreen/${props.theme}/${1}.svg`) }} 
									 src={getImg(`welcomeScreen/${props.theme}/${i+1}.svg`)} alt=""
								/>
								<ActionItem 
									actionLabel={e.actionLabel} 
									actionValue={e.actionValue} 
									handleSubmit={props.handleSubmit} 
									/>
							</CustomQuickLink>
						)
					})
				}
			</QuickLinksBlock>
		</CustomWelcomeBody>
	);
}


export default Theme1;